import WebComponent from '../../WebComponent.js';
import {html} from '../../_snowpack/pkg/lit-html.js';

export default class NoContent extends WebComponent {

    connectedCallback() {
        this.render();
    }

    get cssFile() {
        return './views/NoContent/style.css';
    }

    get translationFile() {
        return './views/NoContent/i18n.json'
    }

    getTemplate() {
        return html`
        <div>
            ${this.i18n.translate('content.not.found')}
        </div>
        `
    }
}

customElements.define('customer-access-no-content', NoContent)